import { UseCaseType } from '@/types/campaign';
import { globalGetService } from '@/utils/globalApiServices';
import { Category, Mno, VerticalType } from './types';

export const getRcsHostingRegions = async () => {
  const response = await globalGetService('enums/hostingRegion');
  return response?.ok ? (response?.data as string[]) : [];
};

export const getRcsBillingCategories = async () => {
  const response = await globalGetService('enums/billingCategory');
  return response?.ok ? (response.data as string[]) : [];
};

export const getUseCaseTypes = async (params?: {
  channelId?: 'RCS' | '10DLC';
  countryCode?: string;
  validSubUsecase?: boolean;
}) => {
  const response = await globalGetService('enums/usecaseTypes', params);
  return response?.ok ? (response?.data as UseCaseType[]) : [];
};

export const getRejectionCategories = async (): Promise<Category[]> => {
  const response = await globalGetService(
    'enums/rejectionCategories',
    {},
    { silent: true }
  );
  return response?.ok ? response.data : [];
};

export const getSuspensionCategories = async (): Promise<
  { id: string; name: string; description: string }[]
> => {
  const response = await globalGetService('enums/suspensionCategories');
  return response?.ok ? response.data : [];
};

export const getMnos = async () => {
  const response = await globalGetService('enums/mnoByCountry');
  return (response?.ok ? response.data : []) as Mno[];
};

export const getVerticalTypes = async () => {
  const response = await globalGetService('enums/verticalTypes');
  return (response?.ok ? response.data : []) as VerticalType[];
};
